<div class="chip">
	<div class="label">
		{{ label | toLocalizedValuePipe }}
	</div>
	<button class="remove" (click)="onRemove()" *ngIf="removable"></button>
</div>
